module.exports = __webpack_public_path__ + "img/seo_icon.18a15904.png";